import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-card" }
const _hoisted_2 = { class: "my-card--body flex flex-row items-center gap-x-5" }
const _hoisted_3 = {
  class: "font-bold",
  style: {"font-size":"75px"}
}
const _hoisted_4 = {
  class: "",
  style: {"font-size":"25px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "stat")
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "label")
      ])
    ])
  ]))
}